import { useState } from "react";
import PropTypes from "prop-types";
import { toast } from "react-toastify";
import { Button, Card, Loader, Popup, ToastErrorTile } from "uikit/components";
import { useBuildReport } from "hooks/reports/useBuildReport";
import { ReactComponent as ExcelIcon } from "./assets/excelIcon.svg";
import styles from "./BuildReportFileTrigger.module.styl";
import cx from "classnames";

function BuildReportFileTrigger({
    formatIcon,
    triggerText,
    triggerClassName,
    downloadText,
    startBuildingReportFunc,
    showAsButton,
}) {
    const [downloadUrl, setDownloadUrl] = useState(null);

    const { build, data, isLoading, reset } = useBuildReport(startBuildingReportFunc, {
        onSuccess: (data) => setDownloadUrl(data.downloadUrl),
        onError: (error) => toast.error(<ToastErrorTile error={error} />),
    });

    const onClose = () => {
        setDownloadUrl(null);
        reset();
    };

    return (
        <>
            {isLoading && (
                <Popup appearance="adaptive">
                    <Loader position={"margin-auto"} text={"Подождите. Данные загружаются."} testName="loader-text" />
                </Popup>
            )}

            {downloadUrl && (
                <Popup appearance="adaptive"
                       title="Подробный отчет сформирован"
                       onClose={onClose}
                       name="popup-container">
                    <p className={styles.reportReadyText}>
                        Нажмите "{downloadText}" для загрузки файла.
                    </p>
                    <Button
                        onClick={onClose}
                        href={data.downloadUrl}
                        target="_blank"
                        rel="noreferrer noopener"
                        testName="popup-action-button"
                    >
                        {downloadText}
                    </Button>
                </Popup>
            )}

            {!showAsButton ? (
                <button
                    className={styles.link}
                    onClick={build}
                    data-test-name={"report_trigger_button"}
                >
                    {formatIcon === "Excel" && <ExcelIcon className={styles.icon} />}
                    <span className={triggerClassName}>{triggerText}</span>
                </button>
            ) : (
                <Card
                    onClick={build}
                    borderRadius={"giant"}
                    padding={"none"}
                    className={styles.button}
                >
                    {formatIcon === "Excel" && (
                        <ExcelIcon
                            className={cx(!showAsButton ? styles.icon : styles.buttonIcon)}
                        />
                    )}
                    <span className={triggerClassName}>{triggerText}</span>
                </Card>
            )}
        </>
    );
}

BuildReportFileTrigger.propTypes = {
    formatIcon: PropTypes.oneOf(["Excel"]),
    triggerText: PropTypes.string.isRequired,
    triggerClassName: PropTypes.string,
    downloadText: PropTypes.string.isRequired,
    startBuildingReportFunc: PropTypes.func.isRequired,
    showAsButton: PropTypes.bool,
};

BuildReportFileTrigger.defaultProps = {
    showAsButton: false,
};

export default BuildReportFileTrigger;
